export default function () {
  return {
    customers: [],
    customer: {},
    customerDetail: {},
    customerTypes: [],
    customerType: {},
    listCustomerTypes: [],
    projects: [],
    customerTableSort: {
      sortBy: 'created_at',
      sortDesc: true
    },

    customerRatings: [],
    customerRating: {},
    listCustomerRatings: [],

    customerInstruments: [],
    customerCategories: [],
    customerSegments: [],
    customerOwnerships: [],

    customerGreetings: [],
    customerGreeting: {},
    listCustomerGreetings: [],
    groups: [
      {
        id: 0,
        name: 'Blank'
      },
      {
        id: 1,
        name: 'Goverment'
      },
      {
        id: 2,
        name: 'Private'
      },
      {
        id: 3,
        name: 'Account/Group'
      },
      {
        id: 4,
        name: 'Employee'
      }
    ],

    titles: [],
    contacts: [],
    contactType: [
      {
        id: 1,
        label: 'Customer'
      },
      {
        id: 2,
        label: 'Vendor'
      },
      {
        id: 3,
        label: 'Lead'
      },
      {
        id: 4,
        label: 'Other'
      }
    ],
    priorities: [
      {
        id: 'low',
        label: 'Low'
      },
      {
        id: 'medium',
        label: 'Medium'
      },
      {
        id: 'high',
        label: 'High'
      }
    ],
    referrals: [
      { id: 1, label: 'RS Rujukan Nasional' },
      { id: 2, label: 'RS Rujukan Provinsi' },
      { id: 3, label: 'RS Rujukan Regional' },
      { id: 4, label: 'RS' },
      { id: 5, label: 'SINE' },
      { id: 6, label: 'Bali & Nusa Tenggara' }
    ],
    mergeSources: [],
    integrationForm: {
      customer: null,

      npwpCopy: false,
      npwpFile: null,
      npwpFileName: null,
      npwpFileType: null,

      idakCopy: false,
      idakFile: null,
      idakFileName: null,
      idakFileType: null,

      cdakbCopy: false,
      cdakbFile: null,
      cdakbFileName: null,
      cdakbFileType: null,

      nitkuCopy: false,
      nitkuFile: null,
      nitkuFileName: null,
      nitkuFileType: null,

      cpLab: null,
      cpLabTlp: null,
      cpFinance: null,
      cpFinanceTlp: null
    },
    iStep: 1
  }
}
